import { message } from "antd";
import { findFirstDuplicateItem } from "./supplier.service";
import { checkItemTitle } from "./inventory.service";

export function validateIngredients(ingredients) {
  if (ingredients.length < 1) {
    message.warning(
      <p className="font-p_regular text-[12px]">
        You need at least one item to save! Please add your ingredient <span className="text-red-500">name</span>,{" "}
        <span className="text-red-500">unit</span>, and <span className="text-red-500">min stocks</span>.
      </p>
    );
    return false;
  }

  for (let idx = 0; idx < ingredients.length; idx++) {
    const ingredient = ingredients[idx];
    if (!ingredient.name || ingredient.name.trim() === "") {
      message.warning(
        <p className="font-p_regular text-[12px]">
          Ingredient<span className="text-red-500"> name</span> is required.
        </p>
      );
      return false;
    }
    
    if (!checkItemTitle(ingredient.name)) {
      message.warning(
        <p className="font-p_regular text-[12px]">
          Ingredient<span className="text-red-500"> name</span> field should contain only alpha numeric, space and
          ,()/'"&:+.
        </p>
      );
      return false;
    }

    if (isNaN(ingredient.minStock) || Number(ingredient.minStock) <= 0) {
      message.warning(
        <p className="font-p_regular text-[12px]">
          Ingredient <span className="text-red-500"> minimum stock</span> is required.
        </p>
      );
      return false;
    }
  }

  // Validate duplicate item
  const arrOfStrs = ingredients.map((item) => item.name);
  const duplicateStr = findFirstDuplicateItem(arrOfStrs);

  if (duplicateStr) {
    message.warning(`Please, remove duplicate item: ${duplicateStr}`);

    return false;
  }

  return true;
}
